<template>
  <div class="chat-container">
    <!-- 聊天主界面 -->
    <div class="chat-main">
      <!-- 聊天消息列表 -->
      <div class="ai-messages" v-if="dhState" ref="chatView">
        <div v-for="(message, index) in messages" :key="message.id || index">
          <!-- 用户消息 -->
          <div class="sender-box flex jfe mb10" v-if="message.role=='user'">
            <p>{{ message.content }}</p>
          </div>
          <!-- AI 回复 -->
          <div class="ai-answer-box flex" v-if="message.role=='assistant'">
            <img class="profile-img"
                 src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/ai_chat_avator.png" alt="AI">
            <div class="flex1 answer-info mb10" v-if="message.content">
              <!-- Markdown 渲染 -->
              <div v-html="compiledMarkdown(message.content)" class="markdown-content"></div>
              <!-- 复制按钮 -->
              <div class="flex ac ">
                <div class="flex ac mb10">
                  <div class="copy-box flex ac cr fs14" style="color: #FAFAFA" @click="handleCopy(message.content)">
                    <i class="el-icon-document-copy mr05"></i>
                    <p>复制</p>
                  </div>
                </div>
                <div class="flex ac mb10">
                  <div class="copy-box ml15 flex ac cr fs14" style="color: #FAFAFA" @click="handleStopTyping()">
                    <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/ai_chat_stop2.png"
                         alt="i">
                    <p>停止</p>
                  </div>
                </div>
                <div class="flex ac mb10 ml15">
                  <div class="copy-box flex ac cr fs14" style="color: #FAFAFA" @click="handleCreate(message.content)">
                    <i class="el-icon-edit mr05"></i>
                    <p>去创作</p>
                  </div>
                </div>
                <div class="flex ac mb10 ml15">
                  <div class="copy-box flex ac cr fs14" style="color: #FAFAFA"
                       @click="handleSave(message.content,index)">
                    <i class="el-icon-folder-add mr05"></i>
                    <p>保存到素材库</p>
                  </div>
                </div>
              </div>

            </div>
            <!-- 加载中状态 -->
            <div v-if="isLoading  && index === messages.length - 1&&!message.content" class="mt20"><i
              class="el-icon-loading"></i></div>


          </div>
        </div>
      </div>

      <!-- 初始对话提示 -->
      <div class="start-dh-title" v-if="!dhState" :style="{ marginTop: !dhState ? '27vh' : '' }">
        <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/22.1_Pic.png" alt="">
      </div>

      <!-- 输入框 -->
      <div class="input-container">
        <el-input
          border="none"
          type="textarea"
          :rows="4"
          placeholder="开启对话吧..."
          v-model="userInput"
          @keyup.enter.native="handleSendMessage"
          :disabled="isLoading"
        ></el-input>

        <div class="flex ac jb">
          <div class="left-choose-box flex ac">
            <div class="every-choose flex ac" @click="handleChooseMx" :class="activeId==1 ? 'choose-active' : ''">
              <p>•</p>
              <img v-if="activeId == 0"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/22.1_Icon_3.png" alt="">
              <img v-if="activeId == 1"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/22.1_Icon_1.png" alt="">
              <p>深度思考 (R1)</p>
            </div>
          </div>
          <div class="right-send-box flex ac">
            <div class="send-button cr" @click="handleSendMessage">
              <img class="send-icon"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/22.1_Icon_5.png" alt="">
            </div>
            <!--            <div class="send-button cr" v-else @click="handleStopTyping">-->
            <!--              <img class="send-icon"-->
            <!--                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/ai_chat_stop.png" alt="">-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <div class="tip-text tc fs12 mt10" style="color:#ffffffAA">
        内容由 AI 生成，请仔细甄别(每次问答将消费您10积分)
      </div>
    </div>

    <!-- 新对话和历史记录 -->
    <div class="flex">
      <div class="new-dh-title flex ac jc cr" @click="startNewConversation">
        <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/22.2_Icon_1.png" alt="">
        <p>开启新对话</p>
      </div>
      <div class="history-sidebar flex cr">
        <div class="history-title flex ac jc cr" v-if="!unfoldState" @click="unfoldState=true">
          <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/22.1_Icon_6.png" alt="">
          <p>历史记录</p>
        </div>
        <div class="history-li-box" v-else>
          <div class="flex ac mb05">
            <img class="sq-icon mr05" v-if="unfoldState"
                 src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/shouqi_icon.png"
                 @click="unfoldState=false" alt="">
            <img class="title-icon" v-else
                 src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/22.1_Icon_6.png" alt="">
            <p>历史记录</p>
          </div>
          <div class="history-sro">
            <div v-for="(history, index) in historyList" :key="history.id" class="every-history"
                 @click="loadHistory(history)" @mouseover="hoverIndex = history.id"
                 @mouseleave="hoverIndex = null">
              <div class="flex ac jb">
                <p class="pp-title te">{{ history.title }}</p>
                <i class="el-icon-delete pb05" v-show="hoverIndex==history.id" @click.stop="handleDel(history)"></i>
              </div>
              <p class="pp-time">{{ history.create_time }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MarkdownIt from "markdown-it";
  import {
    getChatIndex,
    getMessageList,
    postMessage,
    getRecord,
    delRecord,
    postMimicScript,
    textMaterial
  } from "../api/user";
  // import DOMPurify from 'dompurify';
  import {once} from 'lodash';

  export default {
    data() {
      return {
        dhState: false, // 对话状态
        userInput: "",
        messages: [], // 当前对话消息
        historyList: [], // 历史记录列表
        eventSource: null,
        activeId: 0,
        model: "v3",
        cid: "",
        mid: "",
        showBtnState: true, // 控制发送和暂停按钮
        isTyping: false, // 是否正在逐字显示
        isStopped: false, // 是否停止逐字显示
        isUserScrolling: false, // 用户是否手动滚动
        unfoldState: true, // 历史记录展开状态
        hoverIndex: null, // 鼠标悬停的历史记录索引
        isLoading: false,
        currentTypingContent: '', // 当前正在逐字显示的内容
        targetContent: '' // 目标完整内容
      };
    },
    created() {
      this.getOneRecordInfo();
    },
    watch: {
      dhState(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            const content = this.$refs.chatView;
            if (content) {
              content.addEventListener("scroll", this.handleUserScroll);
            }
          });
        }
      }
    },
    methods: {
      // 获取历史记录
      getRecordInfo() {
        getRecord({page: 1, limit: 99999}).then(res => {
          this.historyList = res.data.list;
        });
      },
      // 获取其中一条记录内容
      getOneRecordInfo() {
        getRecord({page: 1, limit: 99999}).then(res => {
          this.historyList = res.data.list;
          if (res.data.list.length > 0 && window.sessionStorage.getItem('cid')) {
            this.cid = window.sessionStorage.getItem('cid')
            this.loadHistory(res.data.list[0])
          }
        });
      },

      // 删除历史记录
      handleDel(item) {
        this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delRecord({id: item.id}).then(res => {
            if (res) {
              this.$message.success('删除成功');
              const index = this.historyList.findIndex(ele => ele.id == item.id);
              if (index !== -1) {
                this.historyList.splice(index, 1);
              }
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      // 滚动到底部
      scrollToBottom() {
        this.$nextTick(() => {
          const content = this.$refs.chatView;
          if (content && !this.isUserScrolling) {
            content.scrollTop = content.scrollHeight;
          }
        });
      },
      // 发送消息
      handleSendMessage() {
        if (!this.userInput.trim() || this.isLoading) return
        const message = this.userInput.trim();
        if (message) {
          if (!window.sessionStorage.getItem('cid')) {
            window.sessionStorage.setItem('cid', this.cid)
          }
          this.showBtnState = false;
          this.isStopped = false;
          this.dhState = true;
          postMessage({cid: this.cid, content: message, model: this.model}).then((res) => {
            this.cid = res.data.cid;
            this.mid = res.data.mid;
            this.messages.push({id: Date.now(), content: message, role: 'user'});
            this.$nextTick(() => {
              const content = this.$refs.chatView;
              if (content) {
                content.scrollTop = content.scrollHeight;
              }
            })
            this.isLoading = true
            this.userInput = "";
            this.fetchAIResponse(message);
          });
        }
      },
      // 获取 AI 响应
      fetchAIResponse(message) {
        if (this.eventSource) {
          this.eventSource.close(); // 关闭之前的连接
        }
        this.messages.push({id: Date.now() + 1, content: '', role: 'assistant'});
        // 防抖更新积分
        const updatePointsOnce = once(() => {
          this.$store.dispatch('updatePoints'), this.isLoading = false
        });

        // 记录当前消息的完整内容
        let currentMessageContent = '';

        this.eventSource = new EventSource(
          `https://s.xingchaoyiqing.com/api/chat/index?token=${this.myHeaders["x-token"]}&cid=${this.cid}&mid=${this.mid}`
        );
        this.eventSource.onmessage = (event) => {
          updatePointsOnce();
          try {
            let d = JSON.parse(event.data);
            if (d && d.message) {
              // 累积文本内容
              currentMessageContent += d.message;
              this.updateMessageContent(currentMessageContent);
            } else {
              // 累积文本内容
              currentMessageContent += event.data;
              this.updateMessageContent(currentMessageContent);
            }
          } catch (error) {
            console.error("Failed to parse JSON:", error);
            // 累积文本内容
            currentMessageContent += event.data;
            this.updateMessageContent(currentMessageContent);
          }
        };
        this.eventSource.onerror = (error) => {
          this.eventSource.close();
        };
      },

      // 更新消息内容（支持可选的逐字效果）
      updateMessageContent(content) {
        const messageIndex = this.messages.length - 1;
        if (messageIndex >= 0) {
          // 始终启用逐字效果
          this.targetContent = content;
          this.startTypewriterEffect(messageIndex);
          // 自动滚动（如果用户没有手动滚动）
          if (!this.isUserScrolling) {
            this.$nextTick(() => this.scrollToBottom());
          }
        }
      },

      // 启动逐字效果
      startTypewriterEffect(messageIndex) {
        if (this.isTyping) {
          // 如果正在打字，更新目标内容
          this.targetContent = this.targetContent;
          return;
        }

        this.isTyping = true;
        this.currentTypingContent = this.messages[messageIndex].content || '';
        this.typeNextChar(messageIndex);
      },

      // 逐字显示下一个字符
      typeNextChar(messageIndex) {
        if (!this.isTyping || this.isStopped) {
          this.isTyping = false;
          return;
        }

        const currentContent = this.messages[messageIndex].content || '';
        const targetLength = this.targetContent.length;

        if (currentContent.length < targetLength) {
          // 添加下一个字符
          const nextChar = this.targetContent.charAt(currentContent.length);
          this.$set(this.messages[messageIndex], 'content', currentContent + nextChar);

          // 自动滚动到底
          this.$nextTick(() => this.scrollToBottom());

          // 继续下一个字符
          setTimeout(() => {
            this.typeNextChar(messageIndex);
          }, 30); // 30ms 间隔
        } else {
          // 完成逐字显示
          this.isTyping = false;
          // 最后再滚动一次，确保到底
          this.$nextTick(() => this.scrollToBottom());
        }
      },

      // 逐字显示文本（保留原方法以备后用，但当前不使用）
      async typeText(text) {
        const messageIndex = this.messages.length - 1;
        const speed = 50;

        while (this.isTyping) await new Promise(resolve => setTimeout(resolve, 50));

        this.isTyping = true;
        this.showBtnState = false;

        let i = 0;
        let lastTime = Date.now();
        let timeoutId = null;

        const type = () => {
          const now = Date.now();
          const elapsed = now - lastTime;
          // 如果页面不可见（切换到后台标签页），补偿显示多个字符
          if (document.visibilityState === 'hidden') {
            const remainingChars = text.length - i;
            const charsToAdd = Math.min(5, remainingChars); // 每次补偿 5 个字符
            this.$set(this.messages[messageIndex], 'content',
              this.messages[messageIndex].content + text.substr(i, charsToAdd));
            i += charsToAdd;
          }
          // 正常逐字显示
          else if (i < text.length && !this.isStopped) {
            this.$set(this.messages[messageIndex], 'content',
              this.messages[messageIndex].content + text.charAt(i));
            i++;
          }

          lastTime = now;

          // 自动滚动（如果用户没有手动滚动）
          if (!this.isUserScrolling) {
            this.$nextTick(() => this.scrollToBottom());
          }

          // 继续打字或结束
          if (i < text.length && !this.isStopped) {
            timeoutId = setTimeout(type, speed);
          } else {
            this.showBtnState = true;
            this.isTyping = false;
          }
        };
        type(); // 开始打字
        // 监听页面可见性变化
        const handleVisibilityChange = () => {
          if (document.visibilityState === 'visible') {
            lastTime = Date.now(); // 重置计时器
          }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        // 组件销毁时清理
        this.$once('hook:beforeDestroy', () => {
          if (timeoutId) clearTimeout(timeoutId);
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        });
      },
      // 处理用户滚动事件
      handleUserScroll() {
        const content = this.$refs.chatView;
        if (content) {
          const isNearBottom = content.scrollTop + content.clientHeight >= content.scrollHeight - 50;
          this.isUserScrolling = !isNearBottom;
        }
      },
      // 开启新对话
      startNewConversation() {
        window.sessionStorage.removeItem('cid')
        this.cid = '';
        this.dhState = false;
        this.messages = [];
        this.handleStopTyping();
        this.getRecordInfo();
      },
      // 切换模型
      handleChooseMx() {
        this.activeId = this.activeId === 0 ? 1 : 0;
        this.model = this.activeId === 0 ? "v3" : "r1";
      },
      // 停止逐字显示
      handleStopTyping() {
        this.showBtnState = true;
        this.isStopped = true;
        this.isTyping = false;
        clearTimeout(this.typeTimeout);

        if (this.eventSource) {
          this.eventSource.close();
          this.eventSource = null;
        }
      },
      handleCreate(val) {
        window.sessionStorage.setItem('createText', JSON.stringify(this.markdownToText(val)))
        this.$router.push({
          path: '/create',
          query: {
            type: 'fk'
          }
        })
      },
      handleSave(val, index) {
        textMaterial({
          name: this.markdownToText(this.messages[index - 1].content),
          source: 'copy_chat',
          text: this.markdownToText(val)
        }).then(res => {
          if (res.code == 0) {
            this.$message.success('保存成功')
          }
        })
      },
      markdownToText(markdown) {
        if (!markdown) return "";
        const md = new MarkdownIt({
          breaks: true
        });
        const html = md.render(markdown);
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
      },
      // 加载历史记录
      loadHistory(history) {
        this.cid = history.id;
        this.isLoading = false
        getMessageList({cid: history.id}).then(res => {
          if (res.data.list.length > 0) {
            this.messages = res.data.list
            this.dhState = true;
          }
        });
      },
      // 复制内容
      async handleCopy(val) {
        if (navigator.clipboard) {
          try {
            await navigator.clipboard.writeText(val);
            this.$message.success('复制成功!');
          } catch (err) {
            this.$message.error('复制失败，请手动复制');
          }
        } else {
          const input = document.createElement('input');
          input.setAttribute('value', val);
          document.body.appendChild(input);
          input.select();
          try {
            document.execCommand('copy');
            this.$message.success('复制成功!');
          } catch (err) {
            this.$message.error('复制失败，请手动复制');
          }
          document.body.removeChild(input);
        }
      },
      // 将 Markdown 转换为 HTML
      compiledMarkdown(markdown) {
        const md = new MarkdownIt({
          breaks: true
        });
        return md.render(markdown || "");
      },

    },
    computed: {
      myHeaders() {
        return {"x-token": window.localStorage.getItem("xcToken") || ""};
      },
    },
    mounted() {
      // 初始化代码
    },
    beforeDestroy() {
      window.sessionStorage.removeItem('cid')
      const content = this.$refs.chatView;
      if (content) {
        content.removeEventListener("scroll", this.handleUserScroll);
      }
      if (this.eventSource) {
        this.eventSource.close();
      }
      clearTimeout(this.typeTimeout);
    },
  };
</script>

<style scoped lang="scss">
  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 22px;
  }

  h3 {
    font-size: 20px;
  }

  .chat-container {
    p {
      margin: 0;
      padding: 0;
    }

    display: flex;
    margin: 0 auto;
    padding: 20px;
  }

  .new-dh-title {
    width: 134px;
    height: 48px;
    background: rgba(25, 27, 47, 0.7);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    font-weight: 500;
    font-size: 14px;
    color: #FAFAFA;

    img {
      display: block;
      margin-right: 4px;
      width: 24px;
      height: 24px;
    }
  }

  .history-sidebar {
    /*width: 360px;*/
    margin-left: 10px;
    height: 100vh;

    .history-title {
      width: 134px;
      height: 48px;
      background: rgba(25, 27, 47, 0.7);
      border-radius: 12px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      font-weight: 500;
      font-size: 14px;
      color: #FAFAFA;

      img {
        display: block;
        margin-right: 4px;
        width: 24px;
        height: 24px;
      }
    }


    .history-li-box {

      width: 420px;
      height: 90vh;
      background: rgba(25, 27, 47, 0.7);
      border-radius: 12px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      color: #FAFAFA;
      font-size: 14px;
      padding: 10px 20px;

      .title-icon {
        width: 24px;
        height: 24px;
      }

      .sq-icon {
        width: 20px;
        height: 20px;
      }

      .history-sro {
        height: 85vh;
        overflow-y: scroll;
        overflow-x: hidden;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* Internet Explorer 10+ */
      }

      .history-sro::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      .every-history {
        width: 380px;
        height: 72px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 8px;
        margin-top: 12px;
        padding: 14px 16px;

        .pp-title {
          font-weight: 500;
          font-size: 14px;
          color: #FAFAFACC;
          line-height: 22px;
          margin-bottom: 4px;
        }

        .pp-time {
          font-weight: 400;
          font-size: 12px;
          color: #FAFAFA66;
          line-height: 18px;
        }
      }
    }
  }

  .history-sidebar h3 {
    margin-bottom: 10px;
  }

  .history-sidebar ul {
    list-style: none;
    padding: 0;
  }

  .history-sidebar li {
    cursor: pointer;
    padding: 5px;
    margin-bottom: 5px;
    background-color: #f0f0f0;
    border-radius: 4px;
  }

  .history-sidebar li:hover {
    background-color: #ddd;
  }

  .history-sidebar button {
    width: 100%;
    padding: 10px;
    margin-top: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .history-sidebar button:hover {
    background-color: #0056b3;
  }

  .chat-main {
    flex: 1;
    padding: 0 20px;
  }

  .ai-messages::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .ai-messages {
    width: 800px;
    height: calc(100vh - 310px);
    overflow-y: scroll;
    /*overflow-x: hidden;*/
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    border-radius: 12px;
    margin: 0 auto;
    padding: 20px;

    .sender-box {
      p {
        mix-width: 606px;
        min-height: 48px;
        background: #26283D;
        border-radius: 12px;
        padding: 10px 20px;
      }

    }

    .ai-answer-box {
      width: 100%;

      .profile-img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin: 10px 10px 0 0;
      }

      .answer-info {
        width: 100%;
        background: #151733;
        border-radius: 12px;
        padding: 0px 20px;

        .copy-box {
          img {
            width: 15px;
            height: 15px;
            margin-right: 5px;
          }

          p {
            min-width: 28px;
            height: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #FAFAFA;
            line-height: 20px;
            text-align: left;
            font-style: normal;
          }
        }
      }
    }
  }

  .You {
    color: #007bff;
  }

  .AI {
    color: #28a745;
  }

  .start-dh-title {
    width: 208px;
    height: 40px;
    margin: 0 auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .input-container {
    padding: 6px 3px;
    width: 800px;
    margin: 40px auto 0;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.15);

    .left-choose-box {
      .every-choose {
        margin-left: 12px;
        cursor: pointer;
        padding: 0 12px;
        height: 32px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 6px;

        font-weight: 400;
        font-size: 12px;
        color: #FAFAFA;

        img {
          display: block;
          margin: 0 4px;
          width: 16px;
          height: 16px;
        }
      }

      .choose-active {
        background: #0DD4FF1A;
        color: #0CE2F6;
      }
    }

    .right-send-box {
      margin-right: 12px;

      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .ml10 {
    margin-left: 10px;
  }

  input {
    flex: 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-right: 10px;
  }

  button {
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  button:hover {
    background-color: #0056b3;
  }
</style>
<style>
  .input-container .el-textarea__inner {
    background-color: transparent !important;
    border: none !important;
    color: #FAFAFA;
  }

  .markdown-content {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    max-width: 100% !important;
  }

  .markdown-content p {
    white-space: pre-wrap !important;
    word-wrap: break-word !important;
  }

  .markdown-content pre {
    white-space: pre-wrap !important;
    word-wrap: break-word !important;
    overflow-x: auto !important;
  }

  .markdown-content code {
    white-space: pre-wrap !important;
    word-wrap: break-word !important;
  }

  .markdown-content h1 {
    font-size: 22px !important;
  }

  .markdown-content h2 {
    font-size: 20px !important;
  }

  .markdown-content h3 {
    font-size: 18px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/aiChat.vue